module.exports = __webpack_public_path__ + "static/FuturaPT-Medium-5fbd70c5077087b45add01329ea35620.woff2";